<div class="pt-mapping container" *ngIf="isCombinedCallLoaded">
	<div>
		<span class="pt-title">PT Image Mapping</span>
		<ng-container *ngIf="isCAPStaff">
			<a href="{{staffURL}}" class="pt-sub-title hidden-sm hidden-md">Return to Staff Portal Home</a>
		</ng-container>
		<ng-container *ngIf="isCommitteeMember">
			<a href="{{capOrgURL}}" class="pt-sub-title">Return to cap.org</a>
		</ng-container>
	</div>

	<!-- SPECIMEN SECTION SERCH :BEGIN -->
	<div class="row" id="mapping" *ngIf="isCAPStaff">
		<div class="col-md-6 pt-value">
			<input id="specimen-radio" type="radio" value="specimen-search" name="search-pt-images-radio" checked (change)="disableCaseForm(true)" />
			<label for="specimen-radio" class="specimen">Specimen-Based Images</label> <br>
			<p>Search for specimen-based image mapping data by entering a mailing.</p>
			<form [formGroup]="mailingForm" (ngSubmit)="mailingFormSubmit()">
				<div class="row">
					<div class="col-md-12 col-sm-12">
						<div class="form-group">
							<label class="label">Mailing:</label>
							<input type="text" name="mailing" formControlName="mailing" class="form-control" placeholder="Enter Mailing" maxlength="15">
							<p class="error" *ngIf="mailingValidation">Enter Valid Mailing ID.</p>
						</div>
					</div>
					<div class="col-md-12 col-sm-12">
						<div class="form-group form-group-md">
							<button type="submit" class="btn" [disabled]="!mailingForm.valid">Search by Mailing</button>
						</div>
					</div>
				</div>
			</form>
		</div>
		<div class="col-md-6 pt-sub-value">
			<p>Search for Specimen-based image mapping data by selecting a year and/or mailings with mapped Images.</p>
			<form [formGroup]="mailingYearForm" (ngSubmit)="mailingYearFormSubmit()">
				<div class="row">
					<div class="col-md-12 col-sm-6">
						<div class="form-group">
							<label class="label">Year:</label>
							<select class="form-control" formControlName="year" (change)="onChangeYear($event)">
								<option *ngFor="let item of mailingYears" value="{{item.year}}">{{item.year}}</option>
							</select>
						</div>
					</div>
					<div class="col-md-12 col-sm-6">
						<div class="form-group">
							<label class="label">Mailings with Mapped Images:</label>
							<select class="form-control" formControlName="mappedImages">
								<option value="">Select Mailings With Mapped Images</option>
								<option *ngFor="let image of mailingMappedImages" value="{{image.mailingId}}">
									{{image.mailingId}}</option>
							</select>
						</div>
					</div>
					<div class="col-md-12 col-sm-12">
						<div class="form-group form-group-md">
							<button class="btn" type="submit" [disabled]="!mailingYearForm.valid">Search by Year</button>
							<button type="reset" class="btn btn-reset">Reset</button>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
	<!-- SPECIMEN SECTION SERCH :END -->

	<!-- CASE SEARCH SECTION :BEGIN -->
	<div id="case-based" class="pt-value">
		<input id="case-base-radio" type="radio" value="case-search" name="search-pt-images-radio" *ngIf="!isCommitteeMember" (change)="disableCaseForm(false)" />
		<label for="case-base-radio" class="specimen"> Case-Based Images </label>
		<p id="program">Program:</p>
		<span>NGC</span>
	</div>
	<div class="basic-search tab-body" [ngClass]="{'active' : isActiveBasic }">
		<div class="row">
			<div class="col-md-7">
				<p class="paragraph">Search for case-based image mapping data by selecting an anatomic site.</p>
				<form [formGroup]="anatomicSiteForm" (ngSubmit)="anatomicSiteFormSubmit()">
					<div class="row">
						<div class="col-md-6 col-sm-6">
							<div class="form-group">
								<label class="label">Anatomic Site:</label>
								<select class="form-control" formControlName="site" (change)="onChangeAnatomicSite($event)">
									<option value="">Select an Anatomic Site</option>
									<option *ngFor="let site of anatomicSiteDesc" value="{{site.code}}">
										{{site.description}}</option>
								</select>
							</div>
						</div>
						<div class="col-md-6 col-sm-6">
							<div class="form-group">
								<label class="label">Anatomic Site Code:</label>
								<input class="form-control" type="text" formControlName="site_no" placeholder="Enter Anatomic Site Code" (keyup)="onKeyUpSelectAnatomicSite($event)" maxlength="20">
								<p class="error" *ngIf="anatomicSiteNoValidation">Enter Valid Anatomic Site #</p>
							</div>
						</div>
						<div class="col-md-12 col-sm-12">
							<div class="form-group form-group-md">
								<button type="submit" class="btn" [disabled]="!anatomicSiteForm.valid">Search by
									Anatomic Site</button>
								<button type="reset" class="btn btn-reset">Reset</button>
							</div>
						</div>
					</div>
				</form>
			</div>
			<div class="col-md-5 case-base-mapping-data">
				<p class="paragraph">Search for case-based image mapping data by entering a case #.</p>
				<form [formGroup]="caseImageMappingForm" (ngSubmit)="caseImageMappingFormSubmit()">
					<div class="row">
						<div class="col-md-12">
							<div class="form-group">
								<label class="label">Case #</label>
								<input class="form-control" type="text" formControlName="case" placeholder="Enter Case #" maxlength="7" />
								<p class="error" *ngIf="caseImageMappingValidation">Enter Valid Case #</p>
							</div>
						</div>
						<div class="col-md-12">
							<div class="form-group form-group-md">
								<button type="submit" class="btn" [disabled]="!caseImageMappingForm.valid">Search by Case #</button>
							</div>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
	<!-- CASE SEARCH SECTION :END -->
</div>